<template>
  <div class="box">
    <div class="box-header">
      <h3>Display Job</h3>
    </div>

    <div class="box-body">
      <div class="grids is-3-desktop gap-20-desktop">
        <div class="card">
          <div class="card-header" v-if="recommended">
            <h3 :class="['card-title', { 'checked': recommended.check }]" @click="setStatusCheck(recommended)">Recommend
            </h3>
          </div>

          <div class="card-body" v-if="recommended">
            <label class="image-label">
              <div class="image">
                <img :src="imageData" alt="" />
                <input :disabled="!recommended.check" class="file-input is-focused" name="Image" ref="fileinput"
                  type="file" @input="onSelectFile()" />
              </div>
            </label>
            <label class="label" v-if="fileSizeError">
              {{ fileSizeError }}
            </label>
            <small v-if="!recommended.check" style="color:red">ກະລຸນາກົດປຸ່ມ Recommend ກ່ອນເລືອກຮູບພາບ</small>
          </div>
        </div>
        <div class="card">
          <div class="card-header" v-if="urgent">
            <h3 :class="['card-title', { 'checked': urgent.check }]" @click="setStatusCheck(urgent)">Urgent</h3>
          </div>
          <div class="card-body">
            <img src="../../../../public/images/urgenjob-sample.png" alt="" />
          </div>
        </div>
        <div class="card">
          <div class="card-header" v-if="hightlight">
            <h3 :class="['card-title', { 'checked': hightlight.check }]" @click="setStatusCheck(hightlight)">Hightlight
            </h3>
          </div>
          <div class="card-body">
            <div class="job-card hightlight">
              <span class="tag"><a>Apply Now</a></span>
              <div class="logo">Logo Here</div>
              <div class="job-desc">
                <h3>Job Title</h3>
                <ul>
                  <li></li>
                  <li></li>
                  <li></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { apolloClient } from "@/services/apollo-client";
import { GET_REUSE } from "@/graphql/manage/query";
export default {
  props: ["info"],
  data: () => ({
    imageData: null,
    fileSizeError: "",
    form: {
      jobZoneId: [],
      tagId: [],
      file: ""
    },
    urgent: null,
    recommended: null,
    hightlight: null
  }),
  methods: {
    async fetchTag() {
      const res = await apolloClient.query({
        query: GET_REUSE,
        variables: {
          type: "Tag",
          page: 1,
          perPage: 1000,
        },
      });
      const tag = res.data.getReuse.reuseType[0]
      this.hightlight = { ...tag, check: false }
    },
    async fetchJobzone() {
      const res = await apolloClient.query({
        query: GET_REUSE,
        variables: {
          type: "JobZone",
          page: 1,
          perPage: 1000,
        },
      });
      const isUrgent = res.data.getReuse.reuseType.find((f) => f.name === "Urgent")
      this.urgent = { ...isUrgent, check: false }
      const isRecommended = res.data.getReuse.reuseType.find((f) => f.name === "Recommended")
      this.recommended = { ...isRecommended, check: false }
    },
    watchAfterGetInfo() {
      const isUrgent = this.form.jobZoneId.find((f) => f === this.urgent._id)
      if (isUrgent) this.urgent.check = true
      const isRecommend = this.form.jobZoneId.find((f) => f === this.recommended._id)
      if (isRecommend) this.recommended.check = true
      const isHightlight = this.form.tagId.find((f) => f === this.hightlight._id)
      if (isHightlight) this.hightlight.check = true
    },
    setStatusCheck(obj) {
      if (obj.name === "Urgent") {
        if (obj.check) {
          this.urgent = { ...this.urgent, check: false }
          this.form.jobZoneId.forEach((el, index) => {
            if (el === obj._id) this.form.jobZoneId.splice(index, 1)
          });
        } else {
          this.urgent = { ...this.urgent, check: true }
          this.form.jobZoneId.push(obj._id)
        }
      } else if (obj.name === "Recommended") {
        if (obj.check) {
          this.recommended = { ...this.recommended, check: false }
          this.form.jobZoneId.forEach((el, index) => {
            if (el === obj._id) this.form.jobZoneId.splice(index, 1)
          })
          this.form.file = ""
          this.imageData = null
        } else {
          this.recommended = { ...this.recommended, check: true }
          this.form.jobZoneId.push(obj._id)
        }
      } else {
        if (obj.check) {
          this.hightlight = { ...this.hightlight, check: false }
          this.form.tagId.forEach((el, index) => {
            if (el === obj._id) this.form.tagId.splice(index, 1)
          })
        } else {
          this.hightlight = { ...this.hightlight, check: true }
          this.form.tagId.push(obj._id)
        }
      }
    },
    chooseImage() {
      this.$refs.fileinput.click();
    },
    async onSelectFile() {
      const input = this.$refs.fileinput;
      const files = input.files;

      const file = files[0];
      const formData = new FormData();

      formData.append("file", file);
      if (file) {
        const filesize = file.size / 1024;
        const size = 5 * 1024;
        if (filesize < size) {
          axios.defaults.headers.common["Authorization"] =
            this.$store.getters.Token;
          const res = await axios.post(`${this.$urlEditorImage}`, formData);
          if (res.data.fileSrc) {
            this.form.file = res.data.fileSrc;
            if (files && files[0]) {
              const reader = new FileReader();
              reader.onload = (e) => {
                this.imageData = e.target.result;
              };
              reader.readAsDataURL(files[0]);
              this.$emit("input is-focused", files[0]);
            }
          }
        } else {
          this.fileSizeError = "The file Size is too much";
          this.imageData = null;
        }
      }
    }
  },
  created() {
    this.fetchJobzone()
    this.fetchTag()
  },
  watch: {
    form: {
      handler(val) {
        if (val) {
          this.$emit('input', val)
        }
      },
      immediate: true,
      deep: true
    },
    "info": {
      handler(value) {
        if (value) {
          this.form.jobZoneId = value.jobZoneId ? value.jobZoneId : []
          this.form.tagId = value.tagId ? value.tagId : []
          this.form.file = value.file ? value.file : ""
          this.imageData = value.file ? value.file : ""
          setTimeout(() => {
            this.watchAfterGetInfo()
          }, 1000);
        }
      },
      immediate: true,
      deep: true
    }
  }
};
</script>

<style lang="scss" scoped>
.card {
  box-shadow: none;
  border-radius: var(--radius);
  border: 1px solid var(--border-color);

  .card-header {
    box-shadow: none;
    padding: 15px 20px;
    border-bottom: 1px solid var(--border-color);
    background-color: var(--light-grey-color);

    .card-title {
      font-size: var(--md-font);
      cursor: pointer;
      margin: 0;
      // f14a
      color: var(--dark-grey-color);

      &.checked {
        color: var(--primary-color);

        &::before {
          content: "\f14a";
          font-family: "Font Awesome 6 Pro";
          font-weight: 700;
        }
      }

      &::before {
        content: "\f0c8";
        font-family: "Font Awesome 6 Pro";
        font-weight: normal;
        margin-right: 5px;
      }
    }
  }
}

.card-body {
  // border: 1px solid var(--border-color);
  // padding: 20px;
  padding: 20px;
  box-shadow: none;
  border-radius: var(--radius);
}

.image-label {
  cursor: pointer;

  input {
    display: none;
  }

  .image {
    width: 100%;
    aspect-ratio: 4/3;
    background-color: var(--light-grey-color);
  }
}

.urgent {
  border: 1px solid var(--border-color);
  padding: 10px;

  p {
    margin: 0;
    font-size: var(--sm-font);
    height: 2rem;
    padding: 0 10px;
    display: flex;
    align-items: center;
    background-color: red;
    color: #fff;
  }
}

.job-card {
  border: 1px solid var(--border-color);
  display: flex;
  gap: 10px;
  padding: 20px;
  box-shadow: 0 0 6px 0 rgba(#000, 0.15);
  position: relative;

  &.hightlight {
    border: 1px solid red;

    .job-desc h3 {
      color: red;
    }

    .tag {
      font-size: 0.5rem;
      background-color: red;
      color: #fff;
      position: absolute;
      top: 0;
      left: 0;
      height: 15px;
      border-radius: 0 0 3px 0;
      padding: 0 15px;

      a {
        animation: bounce 0.8s ease-in-out infinite;

        @keyframes bounce {
          from {
            color: red;
          }

          to {
            color: #fff;
          }
        }
      }
    }
  }

  .logo {
    width: 80px;
    height: 80px;
    background-color: var(--light-grey-color);
    font-size: var(--xxsm-font);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .job-desc {
    font-size: var(--sm-font);
    flex-grow: 1;

    h3 {
      font-size: var(--xsm-font);
      margin: 0;
      color: var(--text-color);
      margin-bottom: 10px;
    }

    ul {
      margin: 0;
      padding: 0;
      list-style-type: none;
      display: flex;
      flex-direction: column;
      gap: 5px;

      li {
        content: "";
        display: block;
        height: 15px;
        width: 100%;
        background-color: var(--light-grey-color);
        margin: 0;
      }
    }
  }
}
</style>
